import { signOut } from 'firebase/auth';
import { LogOut, Menu } from 'lucide-react';
import { auth } from '../config/firebase';

const Header = ({ user, onToggleSidebar }) => {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="bg-gradient-header border-b border-nova-green/20 px-6 py-4 flex items-center justify-between">
      <div className="flex items-center space-x-3">
        {onToggleSidebar && (
          <button
            onClick={onToggleSidebar}
            className="p-2 text-gray-300 hover:text-white hover:bg-nova-green/20 rounded-lg transition-colors"
            aria-label="Toggle sidebar"
          >
            <Menu className="w-5 h-5" />
          </button>
        )}
        <img
          src="/logo.svg"
          alt="NovaSage Logo"
          className="w-10 h-10"
        />
        <div>
          <h2 className="font-semibold text-white">{user.displayName || user.email}</h2>
          <p className="text-xs text-gray-400">{user.email}</p>
        </div>
      </div>
      <button
        onClick={handleSignOut}
        className="flex items-center space-x-2 px-4 py-2 text-gray-300 hover:text-white hover:bg-nova-green/20 rounded-lg transition-colors"
      >
        <LogOut className="w-4 h-4" />
        <span className="text-sm">Sign Out</span>
      </button>
    </div>
  );
};

export default Header;